// extracted by mini-css-extract-plugin
module.exports = {"container":"Wizard_container__1CYw2","screen":"Wizard_screen__3Wizu"};